// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__2ctIM","title":"Card_title__2lyzI","list":"Card_list__3IrBZ","subTitle":"Card_subTitle__2ESd9","buttons":"Card_buttons__3ILem","time":"Card_time__31G-1"};